import React from 'react';
import {faCalendar} from '@fortawesome/pro-solid-svg-icons';
import {
	LegacyFormDialog as FormDialog,
	type LegacyFormDialogProps,
	type LegacyExtendFormDialogProps,
} from '@netx/core-components/FormDialog';
import {useForm, getInputFormObject} from '@netx/core-components/Form';

import {
	ASSET_EXPIRATION_SUBMIT_LABELS,
	ASSET_EXPIRATION_TITLES,
} from '../../locales';
import {AssetExpirationForm} from './AssetExpirationForm';

type FormValues = {
	expirationDate: string | null;
};

export type AssetExpirationProps = Omit<
	LegacyExtendFormDialogProps<true, FormValues>,
	'form'
>;

export const AssetExpiration = ({
	DialogProps,
	...props
}: AssetExpirationProps) => {
	const form = useForm<FormValues>({
		expirationDate: null,
	});
	const inputForm = getInputFormObject(form);

	return (
		<FormDialog<true, FormValues>
			confirmLabel={ASSET_EXPIRATION_SUBMIT_LABELS.EXPIRE}
			title={ASSET_EXPIRATION_TITLES.EXPIRE}
			maxWidth="xs"
			icon={faCalendar}
			{...props}
			{...DialogProps}
			form={form}
		>
			<AssetExpirationForm form={form} inputForm={inputForm} />
		</FormDialog>
	);
};

export default AssetExpiration;
